export interface Role {
    friendlyName: string;
    searchName: string;
}

export const RoleListBuilder = (): Array<Role> => {
    return [
        {
            friendlyName: "Owner",
            searchName: "owner"
        },
        {
            friendlyName: "Consignor",
            searchName: "consignor"
        },
        {
            friendlyName: "Winning Bidder",
            searchName: "winningBidder"
        },
        {
            friendlyName: "Buyer",
            searchName: "buyer"
        },
        {
            friendlyName: "Raised By",
            searchName: "raisedBy"
        },
        {
            friendlyName: "Inspection Contact",
            searchName: "inspectionContact"
        },
        {
            friendlyName: "Signature Contact",
            searchName: "signatureContact"
        }
    ];
};



// WEBPACK FOOTER //
// ./src/model/Role.ts